import React, { useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Link,
  Typography
} from "@mui/material";
import { TablePagination } from "@mui/material";
import { roundTo2 } from '../../utils/constant';
import { useLocation } from "react-router-dom";

export const RecentActivitiesTable = ({
  data = [],
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange,
  onApiNameClick,
  showDetailedView = false
}) => {
  const location = useLocation();
  const isDetailedLogsPage = location.pathname.includes('/detailed-logs');
  
  const headers = showDetailedView 
    ? ["API Name", "Request Time", "Response Time", "HTTP Status", "Status", "Request ID", "Credit Utilized"]
    : ["API Name", "Total Requests", "Success Rate", "Success Count", "Failed Count", "Status", "Credit Utilized"];
  return (
    <Box>
      <Paper sx={{ width: "100%", borderRadius: 3, boxShadow: 2, p: 2 }}>
         <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
        </Box>
        <TableContainer>
          <Table>
          <TableHead>
            <TableRow
              sx={{
                height: 48,
                "& th": {
                  borderBottom: "1px solid #E5E7EB",
                  position: "relative",
                },
              }}
            >
              {headers.map((head, index, arr) => (
                <TableCell
                  key={head}
                  align="center"
                  sx={{
                    fontSize: "13.5px",
                    fontWeight: 700,
                    color: "#111827",
                    paddingY: "10px", 
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      right: 0,
                      top: "50%",
                      transform: "translateY(-50%)",
                      height: "20px",
                      width: "1px",
                      backgroundColor: "#E5E7EB",
                      display: index === arr.length - 1 ? "none" : "block",
                    },
                  }}
                >
                  {head}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}
                sx={{
                  "& td": {
                    borderBottom: "1px solid #E5E7EB",
                  },
                }}>

                  <TableCell align="center" sx={{ fontSize: "13.5px"  }}>
                    {isDetailedLogsPage ? (
                      <Typography sx={{ fontSize: "13.5px" }}>{row.apiName}</Typography>
                    ) : (
                      <Link href="#" underline="hover" onClick={(e) => { e.preventDefault(); onApiNameClick?.(row.apiName); }}>{row.apiName}</Link>
                    )}
                  </TableCell>

                  <TableCell align="center" sx={{ fontSize: "13.5px"  }}>
                    {row.requestTime}
                  </TableCell>

                  <TableCell align="center" sx={{ fontSize: "13.5px" }}>
                    {showDetailedView ? roundTo2(row.responseTime) : row.responseTime}
                  </TableCell>

                  <TableCell align="center" sx={{ fontSize: "13.5px" }}>
                    {row.httpStatus}
                  </TableCell>

                  {!showDetailedView && (
                    <TableCell align="center" sx={{ fontSize: "13.5px" }}>
                      {row.failedCount}
                    </TableCell>
                  )}

                  <TableCell align="center" sx={{ fontSize: "13.5px" }}>
                    {row.status}
                  </TableCell>

                  {showDetailedView && (
                    <TableCell align="center" sx={{ fontSize: "13.5px", }}>
                      {row.sequenceID}
                    </TableCell>
                  )}

                  <TableCell align="center" sx={{ fontSize: "13.5px" }}>
                    {row.creditUtilized}
                  </TableCell>
                </TableRow>
              ))}

              {data.length === 0 && (
                <TableRow>
                  <TableCell align="center" colSpan={showDetailedView ? 7 : 7} sx={{ fontSize: "15px", fontWeight: 600 }}>
                    No Recent Activities found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          component="div"
          count={typeof totalCount === "number" ? totalCount : data.length}
          page={Math.max((page ?? 1) - 1, 0)} 
          onPageChange={(e, newPage) => onPageChange(newPage + 1)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => {
            onPageChange(1); 
            onRowsPerPageChange(Number(e.target.value));
          }}
          rowsPerPageOptions={[5, 15, 25, 50]}
          sx={{
            mt: 2,
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
              fontSize: "12px",
              fontWeight: 600,
            },
            "& .MuiTablePagination-select": {
              fontSize: "12px",
              display: "flex",
              alignItems: "center",
            },
          }}
        />
      </Paper>
    </Box>
  );
};
